/* Arabella homepage: scroll reveal and hero autoplay for the EComposer homepage.
   Kept outside EComposer's generated files so republishing from EComposer doesn't remove it. */
(function () {
  const root = document.getElementById('ecom-home');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal ----------
     Content fades up as it enters from the bottom of the screen. Anything already
     on screen (or above it) when the page loads shows straight away, so nothing
     ever animates while you're already looking at it. */
  const REVEAL_GROUPS = [
    // [selector, stagger children within the same parent]
    ['.ecom-section:not(.ecom-yb56u5wvy2n) .ecom-block:has(> .element__heading)', false],
    ['.ecom-section:not(.ecom-yb56u5wvy2n) .ecom-block:has(> .element__text)', false],
    ['.ecom-section:not(.ecom-yb56u5wvy2n) .ecom-block:has(> .ecom-element-button)', false],
    ['.ecom-sqfg07iljns .ecom-collection__product-item', true],
    ['.ecom-8vl4c6enbet .ecom-swiper-slide', true],
    ['.ecom-45kgkdymfd2 .ecom-column:has(> .core__column--wrapper > .core__blocks > .core__blocks--body > .ecom-block > .ecom-base-image)', true],
    ['.ecom-0ul7egbfua1 .ecom-base-image', false],
    ['.ecom-bprssgp1gcj .ecom-iconlist--item', true],
  ];

  function setupReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    const targets = new Set();
    REVEAL_GROUPS.forEach(([selector, stagger]) => {
      let nodes;
      try {
        nodes = root.querySelectorAll(selector);
      } catch (e) {
        return; // :has() unsupported
      }
      nodes.forEach((el) => {
        // Skip anything nested inside an element that already reveals
        if (el.closest('[data-arh-reveal]')) return;
        el.setAttribute('data-arh-reveal', '');
        if (stagger) {
          const siblings = Array.from(el.parentElement.children);
          el.style.setProperty('--arh-i', Math.min(siblings.indexOf(el), 4));
        }
        targets.add(el);
      });
    });

    document.documentElement.classList.add('arh-js');

    const showNow = (el) => {
      el.classList.add('arh-instant', 'arh-in');
      requestAnimationFrame(() => requestAnimationFrame(() => el.classList.remove('arh-instant')));
    };

    // Slides sitting off to the side of a slider would never "enter" the screen,
    // so everything inside a slider is triggered by the slider itself.
    const groups = new Map();
    targets.forEach((el) => {
      const trigger = el.closest('.ecom-swiper-container') || el;
      if (!groups.has(trigger)) groups.set(trigger, []);
      groups.get(trigger).push(el);
    });

    const viewport = window.innerHeight;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          groups.get(entry.target).forEach((el) => el.classList.add('arh-in'));
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0 }
    );

    groups.forEach((els, trigger) => {
      if (trigger.getBoundingClientRect().top < viewport * 0.98) els.forEach(showNow);
      else observer.observe(trigger);
    });
  }

  /* ---------- Hero autoplay ----------
     EComposer builds the slider after load, so wait for its Swiper instance. */
  function setupHeroAutoplay() {
    if (reduceMotion) return;
    const container = root.querySelector('.ecom-yb56u5wvy2n .ecom-swiper-container');
    if (!container) return;

    let tries = 0;
    (function waitForSwiper() {
      const swiper = container.swiper;
      if (!swiper || !swiper.autoplay) {
        if (tries++ < 80) setTimeout(waitForSwiper, 125);
        return;
      }
      Object.assign(swiper.params.autoplay, {
        enabled: true,
        delay: 5500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      });
      swiper.params.speed = 900;
      swiper.autoplay.start();

      // Pause while the hero is off screen or the tab is hidden
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) swiper.autoplay.start();
          else swiper.autoplay.stop();
        }).observe(container);
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) swiper.autoplay.stop();
        else swiper.autoplay.start();
      });
    })();
  }

  /* ---------- Product slider: "Add to cart" opens the cart drawer ----------
     EComposer's button links to /cart/add, which sends shoppers to the cart page.
     Add the item with the Ajax cart instead and open the theme's cart drawer. */
  const ADD_BUTTON = '.ecom-collection__product-submit.ecom-collection__product-form__actions--add';

  function setupAddToCart() {
    root.querySelectorAll(ADD_BUTTON + ' .ecom-add-to-cart-text').forEach((label) => {
      if (/basket/i.test(label.textContent)) label.textContent = 'Add to cart';
    });

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest(ADD_BUTTON);
        if (!button || !root.contains(button)) return;

        const cartDrawer = document.querySelector('cart-drawer');
        const variantId = button.dataset.id || new URL(button.href, location.origin).searchParams.get('id');
        if (!cartDrawer || typeof cartDrawer.renderContents !== 'function' || !variantId) return;

        // Stop EComposer's own handler and the link from firing
        event.preventDefault();
        event.stopPropagation();
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');

        const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections,
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) {
              // Sold out or over the available quantity: fall back to the product page
              window.location.href = button.closest('.ecom-collection__product-item').querySelector('a[href*="/products/"]').href;
              return;
            }
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents({ ...state, id: Number(variantId) });
          })
          .catch(() => {
            window.location.href = button.href;
          })
          .finally(() => button.removeAttribute('aria-busy'));
      },
      true
    );
  }

  /* ---------- Product slider arrows: centre them on the product photos ---------- */
  function setupSliderArrows() {
    const section = root.querySelector('.ecom-sqfg07iljns');
    if (!section) return;

    const place = () => {
      const arrow = section.querySelector('.ecom-swiper-button');
      const media = section.querySelector('.ecom-collection__product-media-wrapper');
      if (!arrow || !media || !arrow.offsetParent) return;
      const parentTop = arrow.offsetParent.getBoundingClientRect().top;
      const mediaBox = media.getBoundingClientRect();
      const top = mediaBox.top - parentTop + mediaBox.height / 2 - arrow.offsetHeight / 2;
      section.style.setProperty('--arh-nav-top', `${Math.round(top)}px`);
    };

    place();
    window.addEventListener('load', place);
    // The slider resizes its cards after the window resize event, so watch the photo itself
    const media = section.querySelector('.ecom-collection__product-media-wrapper');
    if (media && 'ResizeObserver' in window) new ResizeObserver(place).observe(media);
    else window.addEventListener('resize', place);
  }

  setupReveal();
  setupHeroAutoplay();
  setupAddToCart();
  setupSliderArrows();
})();
